module.exports = __webpack_public_path__ + "static/media/chess_02.2b9f67ea.gif";